// eslint-disable-next-line import/prefer-default-export
export const classByStatus = (status) => {
  switch (status.toLowerCase()) {
    case 'open':
      return 'is-light';

    case 'to do':
      return 'is-info is-light';

    case 'in progress':
      return 'is-info';

    case 'fixed':
      return 'is-success';

    case 'won\'t do':
      return 'is-primary is-light';

    default:
      return 'is-light';
  }
};
